import { render, staticRenderFns } from "./ReasonForAdmission.vue?vue&type=template&id=075d4537&scoped=true"
import script from "./ReasonForAdmission.vue?vue&type=script&lang=js"
export * from "./ReasonForAdmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d4537",
  null
  
)

export default component.exports